export const classList = [
    {
        label: '通知公告',
        value: 1,
        iconName: 'public-info-icon1.png'
    },
    {
        label: '行业动态',
        value: 2,
        iconName: 'public-info-icon2.png'
    },
    {
        label: '政策文件',
        value: 3,
        iconName: 'public-info-icon3.png'
    },
    {
        label: '报名指南',
        value: 4,
        iconName: 'public-info-icon4.png'
    },
    {
        label: '考培资源',
        value: 5,
        iconName: 'public-info-icon5.png'
    },
    {
        label: '网络主播',
        value: 6,
        iconName: 'public-info-icon5.png'
    },
    {
        label: '全媒体运营师',
        value: 7,
        iconName: 'public-info-icon5.png'
    },
    {
        label: '网络信息审核员',
        value: 8,
        iconName: 'public-info-icon5.png'
    },
    {
        label: '优秀案例展示',
        value: 9,
        iconName: 'public-info-icon5.png'
    },
    {
        label: '党建工作',
        value: 10,
        iconName: 'public-info-icon6.png'
    },
    {
        label: '实训直播基地',
        value: 11,
        iconName: 'public-info-icon7.png'
    },
    {
        label: 'AIGC视听创制师',
        value: 20,
        iconName: 'public-info-icon7.png'
    },
    {
        label: '隐藏栏目',
        value: 99,
        iconName: 'public-info-icon5.png'
    }
]
